module.exports = __webpack_public_path__ + "media/images/faramia/background-43f461e8cd2dae048b1f46c0b1d1cfe7.png";